export default __webpack_public_path__ + "static/media/Cloud_Illustration.277e8226.svg";